import { render, staticRenderFns } from "./SectionOverview.vue?vue&type=template&id=3c0ab08f&scoped=true&"
import script from "./SectionOverview.vue?vue&type=script&lang=js&"
export * from "./SectionOverview.vue?vue&type=script&lang=js&"
import style0 from "./SectionOverview.vue?vue&type=style&index=0&id=3c0ab08f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0ab08f",
  null
  
)

export default component.exports